import {memo} from 'react';

import styled from 'styled-components';
import {GoogleOAuthProvider} from '@react-oauth/google';

import {getLocalizationService} from '~/shared/services/localisationService';
import {googleLoginClientKey} from '~/shared/config';

import {LoginWithSectionHeader} from '../loginStyled';

import GoogleSection, {GoogleSectionProps} from './GoogleSection';

const Root = styled.div``;

const OAuthSectionButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface OAtuhSectionProps {
  onSubmitWithGoogleConnect: GoogleSectionProps['onSubmit'];
  openProviderScreen: GoogleSectionProps['openProviderScreen'];
  openLoginScreen?: GoogleSectionProps['openLoginScreen'];
  isRedirectedToStepRef: GoogleSectionProps['isRedirectedToStepRef'];
  fromCheckout?: GoogleSectionProps['fromCheckout'];
  isRegistration?: GoogleSectionProps['isRegistration'];
}

const OAuthSection = ({onSubmitWithGoogleConnect, openProviderScreen, openLoginScreen, isRedirectedToStepRef, fromCheckout, isRegistration}: OAtuhSectionProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      {Boolean(googleLoginClientKey) && (
        <>
          <LoginWithSectionHeader>{t('or')}</LoginWithSectionHeader>
          <OAuthSectionButtonsWrapper>
            <GoogleOAuthProvider clientId={googleLoginClientKey!}>
              <GoogleSection
                openLoginScreen={openLoginScreen}
                openProviderScreen={openProviderScreen}
                onSubmit={onSubmitWithGoogleConnect}
                isRedirectedToStepRef={isRedirectedToStepRef}
                fromCheckout={fromCheckout}
                isRegistration={isRegistration}
              />
            </GoogleOAuthProvider>
          </OAuthSectionButtonsWrapper>
        </>
      )}
    </Root>
  );
};

export default memo(OAuthSection);
